import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import '../../../libs/bulma.min.css';
import './QueuesForm.css';
import './QueuesTable.css';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, exportSelectQueuesByName, valuesAnalyze, changeViewForms, exportUpdateQueues, getMusicOnHoldData } from '../../../services';
import Loading from '../../Loading/LoadingModule';

import QueueInputsUpdate from './components/QueueInputsUpdate';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faUsers } from '@fortawesome/free-solid-svg-icons';

function EndpointsListById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [queues, setQueues] = useState({});
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [moh, setMoh] = useState([]);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const history = useHistory();

  const fetchMusicOnHold = async () => {
    const response = await getMusicOnHoldData();
    return response.data;
  };

  const fetchQueues = async () => {
    const queueListName = await exportSelectQueuesByName({ names: itemsSelectedToEdit.toString() });
    if(queueListName <= 0) return history.push('/config/fila/lista');
    if(queueListName === undefined) return setLoading(true);

    let listQueuesEdited = queueListName.reduce((acc, q) => {
      acc[q.namequeue] = {
        name: q.namequeue,
        music: q.queuemusiconhold,
        strategy: q.queuestrategy,
        autofill: q.queueautofill,
        maxlen: q.queuemaxlen,
        ringinuse: q.queueringinuse,
        announcePosition: q.queueannounceposition,
        announceFrequency: q.queueannouncefrequency,
        announceHoldTime: q.queueannounceholdtime,
        minAnnounceFrequency: q.queueminannouncefrequency,
        queueEntryVarQueue: q.queuesetqueueentryvarqueue,
        wrapuptime: q.queuewrapuptime,
        joinempty: q.queuejoinempty,
        leavewhenempty: q.queueleavewhenempty,
        timeout: q.queuetimeout ? q.queuetimeout : ''
      };
      return acc;
    }, {});

    setQueues(listQueuesEdited);
    setLoading(false);
    return true;
  };

  const joinAndEmptyAnalise = (info) => {
    if (info === 'strict') {
      return 'restrito';
    } else if (info === 'yes') {
      return 'sim';
    } else {
      return 'não';
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    await fetchQueues();

    let fetchMoh = await fetchMusicOnHold();
    if (!idtenant.includes('vgs')) fetchMoh = fetchMoh.filter((moh) => idtenant.includes(moh.accountcode));
    setMoh(fetchMoh);
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar, isNumberNoZero } = valuesAnalyze;

    if(name === 'maxlen' || name === 'announceFrequency' || name === 'minAnnounceFrequency' || name === 'wrapuptime') {
      const checkValueIsNumber = value < 1 ? false : checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    } else {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    };
  };

  const handleChangeQueue = (item) => {
    const { value } = item;

    setValues(queues[value]);
    toggleIsHidden('#update-inputs');
    toggleIsHidden('#updatequeue-save-button');
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value );
    
    if(!Object.keys(validate).includes(false)) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataQueuesUpdate = async () => {
    const queueUpdate = await exportUpdateQueues(values);

    if (queueUpdate['rowCount']){
      toggleIsHidden('#queue-table');
      toggleIsHidden('#updatequeue-save-button');
      toggleIsHidden('#update-inputs');
      toggleIsHidden('#alert-update-queue');
      return setTimeout(() => {
        history.push('/config/fila/lista');
      }, 3000);
    } else {
      toggleIsHidden('#queue-table');
      toggleIsHidden('#updatequeue-save-button');
      toggleIsHidden('#update-inputs');
      toggleIsHidden('#alert-queue-not-update');
      return setTimeout(() => {
        history.push('/config/fila/lista');
      }, 3000);
    }
    return;
  };

  useEffect(() => {
    validateUserLogged()
  }, [validateUserLogged]);

  return (
    <div className="queues-form-container">
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="queues-form-header">
            <div className="queues-form-title-wrapper">
              <svg className="queues-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <div>
                <h1 className="queues-form-title">Lista de Filas</h1>
                <p className="queues-form-subtitle">Edite as configurações dos grupos atendedores</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-queue-not-update" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-queue-not-update')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível alterar a fila selecionada.
              </div>
            </div>

            <div id="alert-update-queue" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-update-queue')}>×</button>
              </div>
              <div className="alert-body">
                Fila atualizada com sucesso!
              </div>
            </div>
          </div>

          <div id="queue-table" className="queues-table-wrapper">
            <table className="queues-table">
              <thead className="queues-table-header">
                <tr>
                  <th>Sel.</th>
                  <th>Fila</th>
                  <th>Música</th>
                  <th>Estratégia</th>
                  <th>Segunda Chamada</th>
                  <th>Descanso</th>
                  <th>Anúncio Posição</th>
                  <th>Anún. T. Estimado</th>
                  <th>Tempo Mínimo An.</th>
                  <th>Frequência</th>
                  <th>Entrar se Vazia</th>
                  <th>Sair se Vazia</th>
                  <th>Max. Chamadas</th>
                  <th>Tempo Transbordo</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(queues).map((queue, index) => {
                  const queueReal = queues[queue];
                  const { name, music, strategy, maxlen, ringinuse, announcePosition, announceFrequency, announceHoldTime, wrapuptime, minAnnounceFrequency, joinempty, leavewhenempty, timeout } = queueReal;
                  return (
                    <tr key={index}>
                      <td><input name="get-queue" id={name} type="radio" value={name} onChange={(e) => handleChangeQueue(e.target)} /></td>
                      <td>{name}</td>
                      <td>{music === 'default' ? 'padrão' : music}</td>
                      <td>{strategy}</td>
                      <td>{ringinuse === 'yes' ? 'sim' : 'não'}</td>
                      <td>{wrapuptime}</td>
                      <td>{announcePosition === 'yes' ? 'sim' : 'não'}</td>
                      <td>{announceHoldTime === 'yes' ? 'sim' : 'não'}</td>
                      <td>{minAnnounceFrequency}</td>
                      <td>{announceFrequency}</td>
                      <td>{joinAndEmptyAnalise(joinempty)}</td>
                      <td>{joinAndEmptyAnalise(leavewhenempty)}</td>
                      <td>{maxlen}</td>
                      <td>{timeout}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div id="update-inputs" className="form-card is-hidden">
            {Object.keys(values).length > 0 ? <QueueInputsUpdate queue={queues} changeValues={handleChangeValues} moh={moh} queueName={values.name} /> : null}
          </div>

          <div id="updatequeue-save-button" className="form-actions is-hidden">
            <button className="btn-submit" type="submit" onClick={() => sendDataQueuesUpdate()} disabled={disable}>
              <FontAwesomeIcon icon={faSave} />
              <span>Salvar</span>
            </button>
          </div>
        </div>
      }
    </div>
  );
}

export default EndpointsListById;
